export default __webpack_public_path__ + "static/media/4table.b98b8123.jpg";